<template>
  <div>
    <v-input type="text" name="name" title="Nom" v-model="user.name"></v-input>
    <v-input type="text" name="lastName" title="Prénom" v-model="user.lastName"></v-input>
    <v-input type="text" name="phone" title="Téléphone" v-model="user.phone"></v-input>
    <v-input type="text" name="siret" title="N° Siret" v-model="user.siret" v-if="officeModule"></v-input>
    <div class="row" v-if="officeModule">
        <div class="col-md-4">
            <div class="portlet-light" style="border: 1px solid #C2CAD8; padding: 1em;">
                <div class="ss-titre text-center">
                    <strong>Logo perso</strong>&nbsp;-&nbsp;<em class="text-center" style="font-size: 11px;">jpg ou png acceptés uniquement</em>
                </div>
                <div class="form-group">
                  <v-image-upload
                      :oldImage="oldImage"
                      name="personalIcon"
                      @image="addNewImage"
                      :index="2"
                      :ratio="1">
                  </v-image-upload>
                </div>
            </div>
        </div>
    </div>
    <div class="margin-top-10">
        <button class="btn green" @click="send">Sauvegarder</button>
    </div>
  </div>
</template>

<script>
export default {

  name: 'UserGeneralForm',
  props: {
    oldImage: {
      type: Object,
      default: () => {
        return {}
      }
    },
    officeModule: {
      type: Boolean,
    },
    user: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      image: new vImageHelper()
    }
  },
  methods: {
    addNewImage(event) {
      this.image.add(event)
    },
    async send() {

      await axios.put(`/user/${this.user.id}`, this.user)

      this.$snotify.success("Profil mis a jour")

      this.image.send(`/user/${this.user.id}/image`)
    }
  }
};
</script>

<style lang="css">
</style>
